import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { TournamentSchema } from '../../schemas/TournamentSchema'

type TAction = {
  tournamentId: string
}

const getInitialState = () =>
  serverResponse<TournamentSchema[]>({
    key: '',
    data: [],
  })

const fetch = reduxFetchCreator<'tournamentFetch', TAction, ReturnType<typeof getInitialState>>(
  'tournamentFetch',
  getInitialState(),
  {
    start: (state, action) => ({ ...state, key: action.payload.tournamentId }),
  },
)

const fetchEpic = epicRequest({
  actionType: fetch.actions.tournamentFetch.type,
  errorAction: fetch.actions.tournamentFetchError,
  // @todo fix type
  fulfilledAction: fetch.actions.tournamentFetchFulfilled,
  request: (action: { payload: TAction }) => `sports/tournament/${action.payload.tournamentId}`,
  // @ts-ignore
  untilTypes: fetch.actions.tournamentFetchCancel.type,
})

const update = reduxFetchCreator('tournamentUpdate', serverResponse<TournamentSchema>())

const tournamentUpdateEpic = epicRequest({
  actionType: update.actions.tournamentUpdate.type,
  debounce: 1000,
  errorAction: update.actions.tournamentUpdateError,
  fulfilledAction: update.actions.tournamentUpdateFulfilled,
  request: ({
    payload,
  }: {
    payload: {
      _avatar?: boolean
      avatar?: Blob
    } & Pick<TournamentSchema, 'id' | 'is_active' | 'is_ended' | 'is_filled' | 'name'>
  }) => {
    const formData = new FormData()
    if (payload.avatar) {
      formData.append('avatar', payload.avatar)
    } else if (payload._avatar) {
      formData.append('_avatar', '1')
    }
    formData.append('name', payload.name)
    formData.append('is_ended', payload.is_ended ? '1' : '0')
    formData.append('is_active', payload.is_active ? '1' : '0')
    formData.append('is_filled', payload.is_filled ? '1' : '0')
    formData.append('_method', 'PUT')

    return {
      body: formData,
      method: 'post',
      url: `sports/tournament/${payload.id}`,
    }
  },
  untilTypes: update.actions.tournamentUpdateCancel.type,
})

const addTeam = reduxFetchCreator<
  'addTeam',
  { teamId: string; tournamentId: string },
  ReturnType<typeof getInitialState>
>('addTeam', getInitialState())

const addTeamEpic = epicRequest({
  actionType: addTeam.actions.addTeam.type,
  errorAction: addTeam.actions.addTeamError,
  // @todo fix type
  fulfilledAction: addTeam.actions.addTeamFulfilled,
  request: ({ payload }: { payload: { teamId: string; tournamentId: string } }) => ({
    body: { ...payload, _method: 'PUT' },
    method: 'post',
    url: `sports/tournament/${payload.tournamentId}/team/${payload.teamId}`,
  }),
  // @ts-ignore
  untilTypes: addTeam.actions.addTeamCancel.type,
})

const stats = reduxFetchCreator<'updateStats', TAction, ReturnType<typeof getInitialState>>(
  'updateStats',
  getInitialState(),
)

const updateStatsEpic = epicRequest({
  actionType: stats.actions.updateStats.type,
  errorAction: stats.actions.updateStatsError,
  // @todo fix type
  fulfilledAction: stats.actions.updateStatsFulfilled,
  request: ({ payload }: { payload: TAction }) => `sports/tournament/${payload.tournamentId}/stats`,
  // @ts-ignore
  untilTypes: stats.actions.updateStatsCancel.type,
})

export const actions = {
  ...addTeam.actions,
  ...stats.actions,
  ...update.actions,
  ...fetch.actions,
}

export const epics = [addTeamEpic, updateStatsEpic, tournamentUpdateEpic, fetchEpic]

export const reducer = reducersMerge(
  stats.reducer,
  addTeam.reducer,
  update.reducer,
  fetch.reducer,
) as typeof stats.reducer
